import { VerifySceneEnum, VerifyStageEnum } from '@/shared/verify-credit-controller/types';

/** 资料检验页面的meta对象 */
export interface VerifyCreditRouterMeta {
  title: string;
  navBarCustomProps: Record<string, unknown>;
  isShowH5Nav: boolean;
  backConfirmDialog: Record<string, unknown>;
}

/** 资料填写各处理类型 */
export enum VerifyEntireTypeEnum {
  /** 授信流程 */
  CREDIT = 'credit',
  /** 提现流程 */
  LOAN = 'loan',
  /** 预授信流程 */
  PRE_CREDIT = 'preCredit',
  /** 编辑模式(非授信、提现场景) */
  MODIFY ='modify',
  /** 活动流程 */
  ACTIVITY = 'activity',
}

/** 场景映射校验内部处理类型 */
export function transformLinkType(scene: VerifySceneEnum): VerifyEntireTypeEnum {
  switch (scene) {
    case VerifySceneEnum.CREDIT_PRE_VERIFY:
    case VerifySceneEnum.CREDIT_PRE_VERIFY_OCR_AFTER:
    case VerifySceneEnum.CREDIT_POST_SUPPLEMENT:
    case VerifySceneEnum.CREDIT_SUPPLY_PERSONAL:
    case VerifySceneEnum.CREDIT_MIX_SUPPLEMENT:
    case VerifySceneEnum.CREDIT_WITH_INVALID_IDENTITY:
    case VerifySceneEnum.CREDIT_MIDDLE_ONLY_OCR:
      return VerifyEntireTypeEnum.CREDIT;
    case VerifySceneEnum.LOAN_UNION_SUPPLEMENT:
    case VerifySceneEnum.LOAN_SUPPLY_PERSONAL:
      return VerifyEntireTypeEnum.LOAN;
    case VerifySceneEnum.PRE_CREDIT_FIRST_INFO:
    case VerifySceneEnum.PRE_CREDIT_ADD_INFO:
    case VerifySceneEnum.POCKET_MONEY_FIRST_INFO:
      return VerifyEntireTypeEnum.PRE_CREDIT;
    case VerifySceneEnum.CREDIT_CASH_ACTIVITY:
      return VerifyEntireTypeEnum.ACTIVITY;
    default:
      return VerifyEntireTypeEnum.MODIFY;
  }
}

/** 联系人配偶关系code */
export const CONTACT_SPOUSE_RELATION_CODE = 3;

/** 验证流程的数据context */
export interface VerifyStageContext {
  /** 是否需要填写“配偶”信息(若已填写，则为false) */
  requireSpouseInfo: boolean
  /** 是否需要锁住其中一个“联系人”是“配偶”(有无填写，都不影响值) */
  lockSpouseInfo: boolean
  /** 是否需要填写”非配偶“的信息(8180-晋商) */
  requireNoSpouseInfo: boolean
  /** 锁定联系人不可选择”配偶“(8180-晋商) */
  lockNoSpouseInfo: boolean
  /** 是否需要展示联系人信息 */
  requireContactsInfo: boolean
}

/** 页面header通知栏的各场景类型 */
export enum HeaderNoticeTypeEnum {
  /** OCR身份证即将过期提醒 */
  IDENTITY_EXPIRES = 'identityExpires'
}

export { VerifyStageEnum };

export interface StateType {
  /** 现金活动是否人群匹配 */
  cashActivityMatch: boolean;
  /** 身份证阶段活动标题文案，用于后端动态文案控制 */
  idCardActivityTitle: string;
  /** 是否正在加载页面配置数据 */
  isLoadingActivityConfig: boolean;
  /** 是否应该显示联系人导入图标 */
  shouldShowContactImportIcon?: boolean;
  /** 联系人导入权限状态，用于曝光埋点 authType（0-未知 1-未决定 2-已授权 3-已拒绝 4-受限制） */
  contactImportAuthType?: number;
}

/** 页面导航栏配置 */
export interface NavBarConfig {
  title: string;
  backgroundImage?: string;
  backgroundColor?: string;
  containerAdaptBgImage?: boolean;
}
